import React, { useEffect } from 'react';
import { CmsSsrComponentProps, ISize } from '@/types/cms';
import { getDeliveryDate } from '@/utils/common/porder';
import ProductCard from '@/components/common/ProductCard/Vertical';
import { AddToCartReferType } from '@/constants/track';
import { useComponentTheme } from '../hooks/useComponentTheme';
import Container from './Container';
import Masonry from 'react-masonry-css';
import classNames from 'classnames';
import SeeMoreBtn from '@/components/vendors/SeeMoreBtn';
import DataSourceEmpty from './DataSourceEmpty';
import { getStaticResData } from '../tools';

const ProductList: React.FC<CmsSsrComponentProps> = props => {
  const {
    componentKey,
    componentInstanceKey,
    componentPosition,
    properties,
    trackingContext,
    staticRes,
    top,
    onDataSourceError,
    isPreview
  } = props;
  const { titleStyle, moreLinkStyle } = useComponentTheme({ properties, pageTheme: 'string' });
  const { result, object } = getStaticResData(staticRes);
  const { products } = (object as { products: ProductType[] }) ?? { products: [] };
  const eventKey = properties?.event_key || componentKey;

  const noData = !result || !Array.isArray(products) || products.length === 0;

  useEffect(() => {
    if (noData) {
      onDataSourceError?.();
    }
  }, [noData, onDataSourceError]);

  if (noData)
    return (
      <DataSourceEmpty componentInstanceKey={componentInstanceKey} componentKey={componentKey}>
        <div className="h-5" />
      </DataSourceEmpty>
    );

  return (
    <Container
      componentKey={componentKey}
      componentInstanceKey={componentInstanceKey}
      properties={properties}
      className="py-2"
      top={top}>
      {(properties?.title || properties?.more_link) && !!products?.length && (
        <div className="px-5 flex pt-3 justify-between items-center">
          <div
            style={{
              color: titleStyle?.color,
              textAlign: titleStyle?.align
            }}
            className={classNames('enki-body-base-medium text-surface-100-fg-default capitalize', {
              ['!text-[14px]']: titleStyle?.font_size === (ISize.small as string),
              ['!text-[17px]']: titleStyle?.font_size === (ISize.middle as string),
              ['!text-[20px]']: titleStyle?.font_size === (ISize.large as string)
            })}>
            {properties?.title}
          </div>
          {properties?.more_link && (
            <SeeMoreBtn
              componentPos={componentPosition}
              trackingContext={trackingContext}
              properties={properties}
              moreLinkStyle={moreLinkStyle}
              cmsComponentKey={componentKey}
              className="bg-[#ffffff]"
            />
          )}
        </div>
      )}
      <Masonry className="flex w-auto pl-0 pr-3 pt-3" columnClassName="bg-clip-padding box-border pl-3">
        {products?.length > 0 &&
          products?.map((item, index) => {
            return (
              <div key={item.id} className="max-w-[357px] bg-clip-padding overflow-hidden mb-4">
                <ProductCard
                  addCartParams={{
                    referType: AddToCartReferType.normal,
                    deliveryDate: getDeliveryDate()
                  }}
                  positionInfoT2={{
                    modSecPos: {
                      mod_nm: eventKey,
                      mod_pos: componentPosition
                    },
                    prodPos: index,
                    context: {
                      tag_key: item?.entrance_tag?.tag_key,
                      tag_name: item?.entrance_tag?.tag_name,
                      ...trackingContext
                    }
                  }}
                  showAllTags={true}
                  data={item}
                  showAddBtn={!isPreview}
                />
              </div>
            );
          })}
      </Masonry>
    </Container>
  );
};

export default ProductList;
